import { Dialog, Transition } from "@headlessui/react";
import { useState, Fragment } from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { POST_USER_INFO } from "services/users";
import ContentAgreement from "component/ContentAgreement";
import Dropdown from "component/Dropdown";

const PopupReAgreement = (props) => {
  const { open, handleClose } = props;
  const { t } = useTranslation();
  const [agree, setAgree] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setLangUpdate] = useState(0);

  const canSubmit = agree && !isSubmitting;

  const handleLangChange = () => {
    setLangUpdate((prev) => prev + 1);
  };

  const handleSubmit = async () => {
    if (!canSubmit) return;

    setIsSubmitting(true);
    try {
      const today = new Date().toISOString().split("T")[0];
      await POST_USER_INFO({
        coupon_agreement: true,
        coupon_agreement_date: today,
      });
      handleClose();
    } catch (error) {
      console.error("Re-agreement submission error:", error);
      toast.error(t("re_agreement_error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Transition show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="max-w-mobile transform overflow-hidden rounded-2xl left align-middle shadow-xl text-left transition-all">
                  <div className="flex flex-col px-6 py-4 pb-8 rounded-3xl bg-primary-100 max-w-[327px]">
                    <div className="flex justify-end mb-2">
                      <Dropdown handleChange={handleLangChange} />
                    </div>

                    <div className="flex flex-col self-stretch px-4 py-3 bg-white rounded-lg border border-solid border-zinc-300 text-black max-h-[50vh] overflow-y-scroll overflow-x-hidden">
                      <div className="justify-center px-4 py-2 text-sm leading-5 text-white bg-neutral-700">
                        {t("overseas_coupon")}
                      </div>
                      <div className="mt-4 leading-5">
                        <ContentAgreement />
                      </div>
                    </div>

                    <div className="flex gap-2 mt-4 items-center">
                      <input
                        id="reAgreeCheckbox"
                        type="checkbox"
                        checked={agree}
                        className="w-5 h-5 bg-white rounded-sm border border-solid border-zinc-300 flex-shrink-0"
                        onChange={(e) => setAgree(e.target.checked)}
                      />
                      <label
                        className="text-sm font-light text-neutral-700 cursor-pointer"
                        htmlFor="reAgreeCheckbox">
                        {t("member_agreement")}
                      </label>
                    </div>

                    <div
                      className={`frame h-9 mt-4 ${!canSubmit ? "opacity-80 cursor-not-allowed" : ""}`}
                      style={{
                        background: !canSubmit ? "#a4a5a6" : undefined,
                        boxShadow: !canSubmit ? "none" : undefined,
                        border: !canSubmit ? "solid 1px #a2a2a2" : undefined,
                      }}
                      onClick={handleSubmit}>
                      <div className="text-wrapper font-hankyu font-bold">
                        {t("re_agreement_agree")}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PopupReAgreement;
